<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Patient </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Patient List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>
                            <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getCustomerList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getCustomerList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="customers.length > 0">
                                        <tr class=" " v-for="(item, i) in customers" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.customer_code }} </td> 
                                            <td>{{ item.name}} </td> 
                                            <td>{{ item.phone }} </td>
                                            <td>{{ item.email }}</td>
                                            <td>{{ item.address }}</td>
                                            <td>{{ item.customer_group_name }}</td> 
                                            <td>
                                                <div class="dropdown float-end">
                                                    <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="mdi mdi-dots-vertical"></i>
                                                    </a>
                                                    <div class="dropdown-menu dropdown-menu-end">
                                                        <!-- item-->
                                                        <a href="#" @click="show(item)" class="dropdown-item text-info"><i class="fa-solid fa-eye"></i> View</a> 
                                                        <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)">
                                                        <i class="mdi mdi-circle-edit-outline me-1"></i>Edit</a>
                                                        <!-- item-->
                                                        <a href="javascript:void(0);" class="dropdown-item text-danger" @click="deleteItem(item)"><i class="mdi mdi-delete-outline me-1"></i>Remove</a>
                                                    </div>
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>Patient Create</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="row  ">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="customer_code">Patients Code *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('customer_code')" v-model="form.customer_code" id="customer_code" placeholder="Patient Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.customer_code">
                                                    {{errors.customer_code[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group col-md-2">
                                            <div class="mb-3">
                                                <label for="emp_code">EMP ID *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('emp_code')" v-model="form.emp_code" id="emp_code" placeholder="EMP ID" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.emp_code">
                                                    {{errors.emp_code[0]}}
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="company_id">Company *</label> 
                                                <select class="form-control border" v-model="form.company_id" @change="onkeyPress('company_id')" id="company_id">
                                                    <option value="0">Select company</option>
                                                    <option v-for="(company, index) in companies" :value="company.id" :key="index">
                                                        {{company.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="customer_group_id">Patient Group *</label> 
                                                <select class="form-control border" v-model="form.customer_group_id" @change="onkeyPress('customer_group_id')" id="customer_group_id">
                                                    <option value="0" selected>Select Patient Group</option>
                                                    <option v-for="(c_group, index) in customer_groups" :value="c_group.id" :key="index"> {{c_group.title}}
                                                    </option>                                                    
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.customer_group_id">
                                                    {{errors.customer_group_id[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="row  ">
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="name">Name *</label>
                                                <input type="text" class="form-control border" @keyup="ledgerAccountNameSetup($event.target.value)" @keypress="onkeyPress('name')" v-model="form.name" id="name" placeholder="Patient Name" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.name">
                                                    {{errors.name[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="email" v-if="form.create_user == 1">Email *</label>
                                                <label for="email" v-else>Email </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('email')" v-model="form.email" id="email" placeholder="Patient Email" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.email">
                                                    {{errors.email[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="form-group col-md-4">
                                            <div class="mb-3">
                                                <label for="phone">Phone *</label>
                                                <input type="text" class="form-control border" @keypress="onkeyPress('phone')" v-model="form.phone" id="phone" placeholder="Patient mobile number"> 
                                                <div class="invalid-feedback" v-if="errors.phone">
                                                    {{errors.phone[0]}}
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="dob">Date of Birth </label>
                                                    <input type="date" 
                                                    class="form-control border" 
                                                    v-model="form.dob" 
                                                    id="dob" 
                                                    @keypress="onkeyPress('dob')"
                                                    @change="dobToAge" 
                                                    placeholder="" 
                                                    autocomplete="off"> 
                                                    <div class="invalid-feedback" v-if="errors.dob">
                                                        {{errors.dob[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-4">
                                            <!-- <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="age">Age </label>
                                                    <input type="number" class="form-control border " @keypress="onkeyPress('age')" v-model="form.age" id="age" placeholder="Ex: 12" autocomplete="off"> 
                                                    <div class="invalid-feedback" v-if="errors.age">
                                                        {{errors.age[0]}}
                                                    </div>
                                                </div>
                                            </div> -->

                                            <div class="form-group mb-3">
                                                <label for="age" style="width: 100%; float: none;">Age</label>
                                                <div class="d-flex gap-2">
                                                    <input type="number"
                                                        class="form-control"
                                                        placeholder="Years"
                                                        min="0"
                                                        v-model.number="age.years"
                                                        @input="validateAge('years'), ageToDob()">

                                                    <input type="number"
                                                        class="form-control"
                                                        placeholder="Months"
                                                        min="0"
                                                        max="11"
                                                        v-model.number="age.months"
                                                        @input="validateAge('months'), ageToDob()">

                                                    <input type="number"
                                                        class="form-control"
                                                        placeholder="Days"
                                                        min="0"
                                                        max="30"
                                                        v-model.number="age.days"
                                                        @input="validateAge('days'), ageToDob()">
                                                </div>

                                                <!-- Hidden / Readonly Final Value -->
                                                <input type="hidden" v-model="form.age">

                                                <small class="text-muted">
                                                    {{ form.age ?? '' }}
                                                </small>

                                                <div class="invalid-feedback d-block" v-if="errors.age">
                                                    {{ errors.age[0] }}
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="gender">Gender *</label>
                                                    <select class="form-control border" v-model="form.gender" @change="onkeyPress('gender')">
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                    </select>
                                                    <div class="invalid-feedback" v-if="errors.gender">
                                                        {{errors.gender[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="blood_group">Blood Group </label> 
                                                    <select class="form-control border" v-model="form.blood_group" @change="onkeyPress('blood_group')" id="blood_group">
                                                        <option value="null" selected>Select Blood Group</option>
                                                        <option value="A+">A+</option>
                                                        <option value="A-">A-</option>
                                                        <option value="AB+">AB+</option>
                                                        <option value="AB-">AB-</option>
                                                        <option value="B+">B+</option>
                                                        <option value="B-">B-</option>
                                                        <option value="O+">O+</option>
                                                        <option value="O-">O-</option>

                                                    </select> 
                                                    <div class="invalid-feedback" v-if="errors.blood_group">
                                                        {{errors.blood_group[0]}}
                                                    </div>
                                                </div>
                                            </div> 
                                        </div>
                                        
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3"> 
                                                    <label for="discount_percent">Discount Percent *</label>
                                                    <input type="number" class="form-control border " @keypress="onkeyPress('discount_percent')" v-model="form.discount_percent" id="discount_percent" placeholder="Discount Percent" autocomplete="off"> 
                                                    <div class="invalid-feedback" v-if="errors.discount_percent">
                                                        {{errors.discount_percent[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="mb-3">
                                                    <label for="status">Status *</label>
                                                    <select class="form-control border" v-model="form.status" @change="onkeyPress('status')">
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </select>
                                                    <div class="invalid-feedback" v-if="errors.status">
                                                        {{errors.status[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div> 
                                    
                                    <div class="row mb-3">
                                        <div class="form-group col-md-4">
                                            <div class="form-group">
                                                <label style="width: 100%">Image (128X128)</label> <br>
                                                <div class="fileinput fileinput-new" data-provides="fileinput" style="position: relative;">
                                                <span class="btn btn-block btn-primary btn-file"><span class="fileinput-new"><i class="fa fa-camera"></i> Chose Image</span>
                                                <span class="fileinput-exists" style="display:none">Change Image</span><input type="file" name="..." @change="onImageChange"/></span>
                                                </div> 
                                                <div class="invalid-feedback" v-if="errors.cimage">
                                                    {{errors.cimage[0]}}
                                                </div>

                                                <img :src="imagePreview" v-if="form.cimage" width="200">
                                                <div v-if="editMode & !imagePreview">
                                                    <img :src="form.cimage" v-if="form.cimage" width="200">
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="form-group col-md-4"> 
                                                    <div class="mb-3" style="text-align: right;">
                                                        <label for="create_user" style="width: 100%">&nbsp;&nbsp;</label>
                                                        <input type="checkbox" class="form-check-input border " @change="onkeyPress('create_user')" true-value="1" false-value="0" v-model="form.create_user" id="create_user"><b> Create User</b>
                                                        <div class="invalid-feedback" v-if="errors.create_user">
                                                            {{errors.create_user[0]}}
                                                        </div>
                                                    </div>
                                                </div>  
                                                <div class="form-group col-md-4" v-if="form.create_user == 1"> 
                                                    <label for="password">Password *</label>
                                                    <input type="password" class="form-control border" @keypress="onkeyPress('password')" v-model="form.password" id="password" placeholder="Password" autocomplete="off"> 
                                                    <div class="invalid-feedback" v-if="errors.password">
                                                        {{errors.password[0]}}
                                                    </div>
                                                </div>  
                                                <div class="form-group col-md-4" v-if="form.create_user == 1"> 
                                                    <label for="password_confirmation">Confirm Password *</label>
                                                    <input type="password" class="form-control border" @keypress="onkeyPress('password_confirmation')" v-model="form.password_confirmation" id="password_confirmation" placeholder="Confirm Password" autocomplete="off"> 
                                                    <div class="invalid-feedback" v-if="errors.password_confirmation">
                                                        {{errors.password_confirmation[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">  
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Address Details </label>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="address">Address 1</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('address')" v-model="form.address" id="address" placeholder="Address 1"> 
                                                <div class="invalid-feedback" v-if="errors.address">
                                                    {{errors.address[0]}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div class="mb-3">
                                                <label for="address_secondary">Address 2</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('address_secondary')" v-model="form.address_secondary" id="address_secondary" placeholder="Address 2"> 
                                                <div class="invalid-feedback" v-if="errors.address_secondary">
                                                    {{errors.address_secondary[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="district_id">District</label>
                                                <select class="form-control border" v-model="form.district_id" @change="onkeyPress('district_id')" id="district_id">
                                                    <option value="0">Select district</option>
                                                    <option v-for="(district, index) in districts" :value="district.id" :key="index"> {{district.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.district_id">
                                                    {{errors.district_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="area_id">Area</label>
                                                <select class="form-control border" v-model="form.area_id" @change="onkeyPress('area_id')" id="district_id">
                                                    <option value="0">Select area </option>
                                                    <option v-for="(area, index) in areas" :value="area.id" :key="index"> {{area.name}}
                                                    </option>
                                                </select> 
                                                <div class="invalid-feedback" v-if="errors.area_id">
                                                    {{errors.area_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <div class="mb-3"> 
                                                <label for="postal_code">Postal Code</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('postal_code')" v-model="form.postal_code" id="postal_code" placeholder="Postal Code" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.postal_code">
                                                    {{errors.postal_code[0]}}
                                                </div>
                                            </div>
                                        </div>
                                         
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Social Details</label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="facebook_url">Facebook URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('facebook_url')" v-model="form.facebook_url" id="facebook_url" placeholder="Facebook URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.facebook_url">
                                                    {{errors.facebook_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="twitter_url">Twitter URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('twitter_url')" v-model="form.twitter_url" id="twitter_url" placeholder="Twitter URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.twitter_url">
                                                    {{errors.twitter_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="instagram_url">Instagram URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('instagram_url')" v-model="form.instagram_url" id="instagram_url" placeholder="Instagram URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.instagram_url">
                                                    {{errors.instagram_url[0]}}
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="form-group col-md-6">
                                            <div class="mb-3"> 
                                                <label for="linkedin_url">Linkedin URL </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('linkedin_url')" v-model="form.linkedin_url" id="linkedin_url" placeholder="Linkedin URL" autocomplete="off"> 
                                                <div class="invalid-feedback" v-if="errors.linkedin_url">
                                                    {{errors.linkedin_url[0]}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                         
                                    </div>


                                    <!-- <div class="row">
                                        <div class="col-md-12">
                                            <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Account Ledger Setup *</label>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="customer_receivable_account">Patient Receivable Account Ledger *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('customer_receivable_account')" v-model="form.customer_receivable_account" id="customer_receivable_account" placeholder="Patient Receivable Account"> 
                                            <div class="invalid-feedback" v-if="errors.customer_receivable_account">
                                                {{errors.customer_receivable_account[0]}}
                                            </div>
                                        </div>
                                    </div> -->

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>

            <!--Bulk Add Customer Modal -->
            <Modal @close="toggleImportModal" :modalActive="importModal">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <button @click="toggleImportModal" type="button" class="btn btn-default">X</button>
                        <h5 style="text-align: right">Import Customers</h5>
                    </div>

                    <div class="modal-body">  
                        <div class="row">
                            <div class="col-md-12">
                                <form role="form" @submit.prevent="submitImportForm()" enctype="multipart/form-data">
                                    <p style="font-size: 13px; font-style: italic;">The field labels marked with * are required input fields.</p>
                                    <p style="font-size: 16px;">The correct column order is (patient_code*, name*, email, phone*, address*, dob, patient_group*, company) and you must follow this.</p>
                                    <p style="font-size: 16px;">Patient Code and Phone both field data must be unique.</p>
                                    <p style="font-size: 16px;">Patient Group and Company Must be enlisted Before Customer Add (if don't have)</p>
                                    
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <label for="excel_file"> Upload EXCEL File *</label>
                                                <input type="file" class="form-control" id="excel_file" ref="file" name="..." @change="customerImportFile(), onkeyPress('excel_file')">
                                                
                                                <div class="invalid-feedback" v-if="errors">
                                                    <p v-for="(error, i) in errors" :key="i">{{ error[0] }}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <label> Sample File</label>
                                                <a :href="samplefile_url" class="btn btn-info" style="display: block; width: 100%; clear:both;" download><i class="fas fa-download"></i> Download</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <button type="submit" class="btn btn-primary" :disabled="disabled_upload">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            
            <!-- Customer Profile Modal -->
            <Modal @close="toggleProfileModal()" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin customer-show-modal">
                    <div class="modal-header"> 
                        <h5 class="">Details Info</h5>
                        <button @click="toggleProfileModal" type="button" class="btn btn-default">X</button>
                    </div>
                    <div class="modal-body" v-if="customer">  
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-5">    
                                            <img :src="customer.cimage" v-if="customer.cimage" width="200">
                                        </div> <!-- end col -->
                                        <div class="col-lg-7"> 
                                            <!-- Product title -->
                                            <div class="col-md-12">
                                                <h3 class="mt-0">{{ customer.name }}  </h3>  
                                                <table class="table table-responsive">
                                                    <tr>
                                                        <td>Phone: </td>
                                                        <td>{{ customer.phone }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email: </td>
                                                        <td>{{ customer.email }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address: </td>
                                                        <td>{{ customer.address }}</td>
                                                    </tr>
                                                </table>
                                            </div>  

                                        </div> <!-- end col -->
                                    </div> <!-- end row-->
                                    <div class="table-responsive mt-4">
                                        <table class="table table-bordered table-centered mb-0"> 
                                            <tbody>
                                                <tr>
                                                    <td>Patient Type</td>
                                                    <td>{{ customer.customer_group_name }}</td> 
                                                </tr> 
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{{ customer.gender }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Date of Birth</td>
                                                    <td>{{ customer.dob }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Blood Group</td>
                                                    <td>{{ customer.blood_group }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>
                                                    <span class="badge bg-success" v-if="customer.status">Active</span> 
                                                    <span class="badge bg-danger" v-else>Inactive</span> 
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td>Address 2</td>
                                                    <td>{{ (customer.address_secondary != 'null') ? customer.address_secondary : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Facebook URL</td>
                                                    <td>{{ (customer.facebook_url != 'null') ? customer.facebook_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Twitter URL</td>
                                                    <td>{{ (customer.twitter_url != 'null') ? customer.twitter_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Instagram URL</td>
                                                    <td>{{ (customer.instagram_url != 'null') ? customer.instagram_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Linkedin URL</td>
                                                    <td>{{ (customer.linkedin_url != 'null') ? customer.linkedin_url : '' }}</td> 
                                                </tr>
                                                
                                            </tbody>
                                            </table>
                                        </div> 
                                    <div class="col-md-12"> 
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            
                                        </div>
                                    </div>
                                    </div>
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div> <!-- end col-->  
                    </div>
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "./../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Customer',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            disabled_upload: false,
            modalActive:false,
            importModal: false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            items: [],
            customers: [],
            customer_groups: [],
            districts: [],
            areas: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                customer_code: '', 
                emp_code: '', 
                company_id: 0, 
                customer_group_id: 1, 
                name: '',
                email: '',
                phone: '',
                dob: '',
                age: '',
                discount_percent: 0,
                blood_group: null,
                gender: 'male',
                status: 1,
                cimage: '',
                create_user: '',
                password: '',
                password_confirmation: '',

                address: '',
                address_secondary: '',
                district_id: '0',
                area_id: '0',
                postal_code: '',

                facebook_url: '',
                twitter_url: '',
                instagram_url: '',
                linkedin_url: '',
                
                wholesale_customer: 0,
                sale_without_vat: 0,
                credit_customer: 0,
                store_customer: 0,

                customer_receivable_account: '',
            }),
            age: {
                years: '',
                months: '',
                days: ''
            },
            isUpdating: false,
            importFile: '',
            samplefile_url: this.baseUrl+'/import_excel_demo/customers.xlsx',
            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                },   
                {
                    label: 'Code',
                    name: 'customer_code',           
                    width: '10%'
                },   
                {
                    label: 'Name',
                    name: 'name',
                    width: '15%'
                },
                {
                    label: 'Phone',
                    name: 'phone',
                    width: '10%'
                },
                {
                    label: 'Email',
                    name: 'email',
                    width: '10%'
                },
                {
                    label: 'Address',
                    name: 'address',
                    width: '10%'
                },
                {
                    label: 'Group Name',
                    name: 'customer_group_name',
                    width: '15%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'name', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getCustomerList();
        this.fetchIndexData();
        this.fetchCompany()
        this.fetchDistrict()
        this.fetchArea();
        this.fetchCustomerGroup(); 
    },
    methods: { 
        toggleImportModal: function() {
            this.importModal = !this.importModal;
            this.importFile = '';
            this.$refs.file.value=null;
            this.disabled_upload = true;
            this.errors = '';
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
            this.age = {
                years: '',
                months: '',
                days: ''
            }
            this.isUpdating = false;
        },
         
        toggleProfileModal: function() {  
            this.showModal = !this.showModal;
        },

        fetchIndexData() { 
            axios.get(this.apiUrl+'/customers', this.headerjson)
            .then((res) => {
                this.items = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 
        fetchCustomerGroup() { 
            axios.get(this.apiUrl+'/customer_groups', this.headerjson)
            .then((res) => {
                this.customer_groups = res.data.data; 
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 
        fetchDistrict() { 
            axios.get(this.apiUrl+'/districts', this.headerjson)
            .then((res) => {
                this.districts = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },
        fetchArea() { 
            axios.get(this.apiUrl+'/areas',this.headerjson)
            .then((res) => {
                this.areas = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        }, 
        
        customerImportFile() {
            this.importFile = this.$refs.file.files[0];
            if(this.importFile != '') {
                this.errors = ''
            }
        },

        checkImportRequiredPrimary() {
            if(this.$refs.file.value != "") {
                this.disabled_upload = false;
            }else{
                this.disabled_upload = true;
            }
        },

        parseAge(ageString) {
            const match = ageString.match(/(\d+)y\s*(\d+)m\s*(\d+)d/)
            if (match) {
                this.age.years  = Number(match[1])
                this.age.months = Number(match[2])
                this.age.days   = Number(match[3])
            }else{
                if(ageString) {
                    this.age.years = ageString;
                    this.updateAge();
                }
            }
        },

        validateAge(field) {
            if(field === 'years' && this.age.years < 0) {
                this.age.years = 0;
            }
            if(field === 'months') {
                if(this.age.months < 0) {
                    this.age.months = 0;
                } else if(this.age.months > 11) {
                    this.age.months = 11;
                }
            }
            if(field === 'days') {
                if(this.age.days < 0) {
                    this.age.days = 0;
                } else if(this.age.days > 29) {
                    this.age.days = 29;
                }
            }
        },

        updateAge() {
            let y = this.age.years || 0
            let m = this.age.months || 0
            let d = this.age.days || 0

            this.form.age = `${y}y ${m}m ${d}d`
        },

        dobToAge() {
            if (!this.form.dob || this.isUpdating) return
            this.isUpdating = true

            const dob = new Date(this.form.dob)
            const today = new Date()

            let years = today.getFullYear() - dob.getFullYear()
            let months = today.getMonth() - dob.getMonth()
            let days = today.getDate() - dob.getDate()

            if (days < 0) {
                months--
                days += new Date(today.getFullYear(), today.getMonth(), 0).getDate()
            }

            if (months < 0) {
                years--
                months += 12
            }

            this.age.years = years
            this.age.months = months
            this.age.days = days
            this.form.age = `${years}y ${months}m ${days}d`

            this.isUpdating = false
        },

        ageToDob() {
            if (this.isUpdating) return
            this.isUpdating = true

            const today = new Date()
            let dob = new Date(today)

            dob.setFullYear(dob.getFullYear() - (this.age.years || 0))
            dob.setMonth(dob.getMonth() - (this.age.months || 0))
            dob.setDate(dob.getDate() - (this.age.days || 0))

            this.form.dob = dob.toISOString().slice(0, 10)
            this.form.age = `${this.age.years || 0}y ${this.age.months || 0}m ${this.age.days || 0}d`

            this.isUpdating = false
        },

        // Ledger Account Name Setup
        ledgerAccountNameSetup: function(value) {
            // this.form.customer_receivable_account = value;
        },

        show: function(item) {     
            axios.get(this.apiUrl+'/customers/'+item.id, this.headers).then(res => {
                if(res.status == 200){  
                    this.customer = res.data.data
                    this.showModal = !this.showModal;  
                }else{
                    this.$toast.error(res.data.message);
                }
                console.log(res.data.data)
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            }) 
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);  
            if(this.form.age) {
                this.parseAge(this.form.age);
            }
            this.form.create_user = 0;
        },
        checkForm: function(e) {

        },
        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            formData.append('customer_code', this.form.customer_code);
            // formData.append('emp_code', this.form.emp_code);
            formData.append('company_id', this.form.company_id);
            formData.append('customer_group_id', this.form.customer_group_id);
            formData.append('name', this.form.name);
            formData.append('email', this.form.email);
            formData.append('phone', this.form.phone);
            formData.append('dob', this.form.dob);
            formData.append('age', this.form.age);
            formData.append('discount_percent', this.form.discount_percent);
            formData.append('blood_group', this.form.blood_group);
            formData.append('gender', this.form.gender);
            formData.append('status', this.form.status);
            formData.append('create_user', this.form.create_user);
            formData.append('password', this.form.password);
            formData.append('password_confirmation', this.form.password_confirmation);

            formData.append('address', this.form.address);
            formData.append('address_secondary', this.form.address_secondary);
            formData.append('district_id', this.form.district_id);
            formData.append('area_id', this.form.area_id);
            formData.append('postal_code', this.form.postal_code);

            formData.append('facebook_url', this.form.facebook_url);
            formData.append('twitter_url', this.form.twitter_url);
            formData.append('instagram_url', this.form.instagram_url);
            formData.append('linkedin_url', this.form.linkedin_url);
            
            formData.append('wholesale_customer', this.form.wholesale_customer);
            formData.append('sale_without_vat', this.form.sale_without_vat);
            formData.append('credit_customer', this.form.credit_customer);
            formData.append('store_customer', this.form.store_customer);

            formData.append('customer_receivable_account', this.form.customer_receivable_account);
            if(this.editMode){
                formData.append('_method', 'put');
                if(this.imagePreview){
                    this.form.cimage ? formData.append('cimage', this.form.cimage, this.form.cimage.name) : '';
                } 
                var postEvent = axios.post(this.apiUrl+'/customers/'+this.form.id, formData, this.headers);
            }else{  
                this.form.cimage ? formData.append('cimage', this.form.cimage, this.form.cimage.name) : '';
                var postEvent = axios.post(this.apiUrl+'/customers', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchIndexData();
                    this.getCustomerList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        submitImportForm: function(e) {  
            this.isSubmit = true;
            this.disabled_upload = true;
            const formData = new FormData();
            formData.append("excel_file", this.importFile);
                    
            var postEvent = axios.post(this.apiUrl+'/customers/customerBulkUpload', formData, this.headers);

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled_upload = false;
                if(res.status == 200){
                    this.importFile = '';
                    this.disabled_upload = true;
                    this.toggleImportModal();
                    this.fetchIndexData();
                    this.getCustomerList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => { 
                this.isSubmit = false; 
                this.importFile = '';
                this.$refs.file.value=null;
                this.disabled_upload = true;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            });
        },

        onImageChange(e) {
            this.form.cimage = e.target.files[0]
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;  
            
            this.createImage(files[0]);

        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => { 
                vm.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            this.checkImportRequiredPrimary();
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this customer!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/customers/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchIndexData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getCustomerList(url = this.apiUrl+'/customers/list') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.customers = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getCustomerList();
        },
        setPage(data){  
            this.getCustomerList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>